<template>
  <div class="absolute top-21 left-170.25 z-10 w-1 h-23">
    <div class="w-full h-full rounded-sm bg-linear-to-b from-white to-[#BEFF57]" />
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
